import SubAccountForm from "./SubAccountForm";
import type { SubAccount } from "src/types/customer";

interface AddSubAccountProps {
	customer_id?: string | number;
	/** Only supplied when editing an existing record. */
	subAccount?: SubAccount;
}

/** Add or edit a sub account for a known parent customer (opened from the customer profile). */
const AddSubAccount = ({ customer_id, subAccount }: AddSubAccountProps) => (
	<SubAccountForm customer_id={customer_id} subAccount={subAccount} invalidateKey="customers" />
);

export default AddSubAccount;
